import React, { useState } from 'react';
import {  Grid, Icon, Popup } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';
import { VoicemailPlayback } from 'dyl-components';

const OfficeViewCallRecording = ({ 
    currentCallPhoneNumber,
    duration = 0,
    callRecording,
    voicemail = false,
    onMarkVoicemailAsListened,
    isInternalCall,
    isPrimaryPhone,
    isDialer
 }) => {
    const [isVoicemailPlaybackOpen, setIsVoicemailPlaybackOpen] = useState(false);

    return (
        <Grid className="OfficeViewCallRecording" columns="equal">
            <Grid.Row>
                <Grid.Column width={isDialer ? 8 : 3}>
                    {!isInternalCall ? PhoneUtil.formatPhoneNumber(currentCallPhoneNumber) : `Ext. ${currentCallPhoneNumber}`}
                    {isPrimaryPhone && <Icon name='star' color='blue' style={{ marginLeft: 4 }} />}
                </Grid.Column>
                <Grid.Column>
                    <Popup
                        style={{minWidth:400}}
                        trigger={
                            <Icon
                                className={`fa-solid fa-${voicemail ? "voicemail" : "circle-play"}`}
                                style={{ marginRight: 6, cursor: 'pointer' }} 
                                disabled={!!!callRecording?.url}
                                color="primary"
                            /> 
                        }
                        on="click"
                        content={
                            <VoicemailPlayback
                                onClose={() => setIsVoicemailPlaybackOpen(false)}
                                className={`audio-playback-${callRecording?.sound_id}`}
                                fileName={voicemail ? "Voicemail" : "Call Recording"}
                                link={callRecording?.url}
                                onMarkAsListened={onMarkVoicemailAsListened}
                                isVoicemail={voicemail}
                            />
                        }
                        position="bottom center"
                        open={isVoicemailPlaybackOpen}
                        onOpen={() => setIsVoicemailPlaybackOpen(true)}
                    />
                    Duration: {PhoneUtil.timeTicker(duration)}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
};

export default OfficeViewCallRecording;
